import React, { useRef, useEffect } from "react";
import { Toast } from "primereact/toast";
import "./style.scss";

const DeleteToast = ({
  successMsg,
  setMessages,
  position = "bottom-right",
}) => {
  const toast = useRef(null);
  const hasShown = useRef(false);
  const toastLife = 3000;

  useEffect(() => {
    if (successMsg && toast.current && !hasShown.current) {
      hasShown.current = true;

      toast.current.show({
        severity: "error",
        detail: (
          <div className="flex align-items-center justify-content-between delete-success-toast">
            <span className="p-message">{successMsg}</span>
          </div>
        ),
        icon: "pi pi-trash",
        life: toastLife,
        closable: true,
      });
      setTimeout(() => {
        hasShown.current = false;
        setMessages("");
      }, toastLife + 100);
    }

    if (!successMsg) {
      setMessages("");
      hasShown.current = false;
    }
  }, [successMsg]);

  return successMsg && <Toast ref={toast} position={position} />;
};

export default DeleteToast;
